import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'i2a-resource-nodata',
  templateUrl: './resource-nodata.component.html',
  styleUrls: ['./resource-nodata.component.scss']
})
export class ResourceNodataComponent implements OnInit {
  @Input() public resourceKey:string;
  
  constructor() { }

  ngOnInit() {
  }

}
